// import { DsfSCLoading } from "./loading"; // 加载中
// import { DsfSCPanel } from "./panel"; // 面板
// import { DsfSCBlock } from "./block"; // 方块
// import { DsfSCSchedule,DsfTJYSchedule, DsfTeasUniteScheduleList, DsfTjyUniteScheduleList } from "./schedule"; // 日程安排

// 对外弹窗显示组件
export const DsfNetcomDetailMore = dsf.defineAsyncComponent("DsfNetcomDetailMore", () =>
  import(/* webpackChunkName: "netcom_detail_more" */ "../views/login1/NetcomDetailMore.vue")
);

// 加载中
 export const DsfSCLoading = Vue.defineLazyComponent(() =>
  require("./loading/Loading.vue")
);
 
// 面板
export const DsfSCPanel = Vue.defineLazyComponent(() =>
  require("./panel/Panel")
);
// 方块
export const DsfSCBlock = Vue.defineLazyComponent(() =>
  require("./block/Block")
);
// 自定义Home
export const DsfSCaHome = Vue.defineLazyComponent(() =>
  require("./aHome.vue")
);


// 日程安排
export const DsfSCSchedule = Vue.defineLazyComponent(() =>
  require(/* webpackChunkName: "statistics_cloud_schedule" */"./schedule/Schedule.vue")
);
export const DsfTJYSchedule = Vue.defineLazyComponent(() =>
  require(/* webpackChunkName: "statistics_cloud_schedule" */"./schedule/TjySchedule.vue")
);
export const DsfTeasUniteScheduleList = Vue.defineLazyComponent(() =>
  require(/* webpackChunkName: "statistics_cloud_schedule" */"./schedule/teasUnite/TeasUniteScheduleList.vue")
);
export const DsfTjyUniteScheduleList = Vue.defineLazyComponent(() =>
  require(/* webpackChunkName: "statistics_cloud_schedule" */"./schedule/teasUnite/TjyUniteScheduleList.vue")
);





// 驾驶舱
export const DsfSCAreaInformant = Vue.defineLazyComponent(() =>
  require("./../views/leaderCockpit/AreaInformant.vue")
);
// import DsfSCAreaInformant from "./../views/leaderCockpit/AreaInformant.vue"; // 各地区填报数（当日）TOP5
// import DsfSCAreaWare from "./../views/leaderCockpit/AreaWare.vue"; // 各系统入库数据情况
export const DsfSCAreaWare = Vue.defineLazyComponent(() =>
  require("./../views/leaderCockpit/AreaWare.vue")
);
// import DsfSCDataOverview from "./../views/leaderCockpit/DataOverview.vue"; // 数据总览
export const DsfSCDataOverview = Vue.defineLazyComponent(() =>
  require("./../views/leaderCockpit/DataOverview.vue")
);
// 普通门户
// import DsfSCDataCenter from "./../views/normalUser/DataCenter.vue"; // 年度数据中心
export const DsfSCDataCenter = Vue.defineLazyComponent(() =>
  require("./../views/normalUser/DataCenter.vue")
);
// import DsfSCInformCenter from "./../views/normalUser/InformCenter.vue"; // 通知中心
export const DsfSCInformCenter = Vue.defineLazyComponent(() =>
  require("./../views/normalUser/InformCenter.vue")
);
// import DsfSCTodoCenter from "./../views/normalUser/TodoCenter.vue"; // 待办中心
export const DsfSCTodoCenter = Vue.defineLazyComponent(() =>
  require("./../views/normalUser/TodoCenter.vue")
);
// 专业门户
// import DsfSCCommonTools from "./../views/speciallyUser/CommonTools.vue"; // 常用功能
export const DsfSCCommonTools = Vue.defineLazyComponent(() =>
  require("./../views/speciallyUser/CommonTools.vue")
);
// import DsfSCMessageBulletin from "./../views/speciallyUser/MessageBulletin.vue"; // 消息公告
export const DsfSCMessageBulletin = Vue.defineLazyComponent(() =>
  require("./../views/speciallyUser/MessageBulletin.vue")
);
// import DsfSCTodoWork from "./../views/speciallyUser/TodoWork.vue"; // 待办事项
export const DsfSCTodoWork = Vue.defineLazyComponent(() =>
  require("./../views/speciallyUser/TodoWork.vue")
);
// import DsfSCWarningRemind from "./../views/speciallyUser/WarningRemind.vue"; // 预警提醒
export const DsfSCWarningRemind = Vue.defineLazyComponent(() =>
  require("./../views/speciallyUser/WarningRemind.vue")
);
// import DsfSCTodoWorkList from "./todoWorkList/TodoWorkList.vue"; // 预警提醒
export const DsfSCTodoWorkList = Vue.defineLazyComponent(() =>
  require("./todoWorkList/TodoWorkList.vue")
);
export const DsfStatsCloudUserImportPanel = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "statustics_cloud_improt" */ "./userImport/userImport.vue"
  )
);

// import { DsfSCCountTo } from "./number";
export const DsfSCCountTo = Vue.defineLazyComponent(() =>
  require("./number/countTo")
);

import { DSFSCSurveyProjectList } from "./surveyProject";
import { DSFSCAreaInformantTable } from "./areaInformantTable";
import { DsfScStaticList } from "./list";
import { DsfSWrokCOverviewStting } from "./workOverviewSetting";
// import DsfProjectStatisticsCloudLogs from "./logs/logs.vue";
export const DsfProjectStatisticsCloudLogs = Vue.defineLazyComponent(() =>
  require("./logs/logs.vue")
);
export const DsfAccountInfo = Vue.defineLazyComponent(() =>
  require("./accountInfo/index.vue")
);
// import DsfAccountInfo from "./accountInfo/index.vue";

import {
  DsfSCBiaofulu,
  DsfSCBiaotou,
  DsfSCBiaowei,
  DsfSCBudaimulubudingchang,
  DsfSCDaimulubudingchang,
  DsfSCErweidanlie,
  DsfSCErweishuanglie,
  DsfSCWenjuanbiao,
} from "./tableDesign";

// import { DsfLeftImgCard, DsfleftImgCards } from "./card/index";
// export const DsfLeftImgCard = Vue.defineLazyComponent(() =>
//   import(/* webpackChunkName: "left_img_card" */"./card/leftImgCard")
// );
// export const DsfleftImgCards = Vue.defineLazyComponent(() =>
//   import(/* webpackChunkName: "left_img_card" */"./card/leftImgCards")
// );




// const components = {
//   DsfSCLoading,
//   DsfSCPanel,
//   DsfSCBlock,
//   DsfSCSchedule,
//   DsfTJYSchedule,
//   DsfTeasUniteScheduleList,
//   DsfTjyUniteScheduleList,
//   DsfSCAreaInformant,
//   DsfStatsCloudUserImportPanel,
//   DsfSCAreaWare,
//   DsfSCDataOverview,
//   DsfSCDataCenter,
//   DsfSCInformCenter,
//   DsfSCTodoCenter,
//   DsfSCCommonTools,
//   DsfSCMessageBulletin,
//   DSFSCSurveyProjectList,
//   DsfSCTodoWork,
//   DsfSCWarningRemind,
//   DsfSCTodoWorkList,
//   DsfSCBiaofulu,
//   DsfSCBiaotou,
//   DsfSCBiaowei,
//   DsfSCBudaimulubudingchang,
//   DsfSCDaimulubudingchang,
//   DsfSCErweidanlie,
//   DsfSCErweishuanglie,
//   DsfSCWenjuanbiao,
//   DsfSCCountTo,
//   DSFSCAreaInformantTable,
//   DsfScStaticList,
//   DsfLeftImgCard,
//   DsfleftImgCards,
//   DsfSWrokCOverviewStting,
//   DsfProjectStatisticsCloudLogs,
//   DsfAccountInfo,
// };
// function install(Vue) {
//   for (let key in components) {
//     let it = components[key];
//     let name = dsf.isFunction(it) ? it.ctrlName || key : it.name;
//     Vue.component(name, it);
//     if (!window.$components["statisCloud"]) {
//       window.$components["statisCloud"] = {};
//     }
//     window.$components["statisCloud"][name] = it;
//   }
// }
// export default install;

// export { install };
